import React from 'react';
import {List, Dropdown, Button, Icon, Rating} from 'semantic-ui-react';
import {Media} from 'src/utils/Media';
import {withTranslation} from 'react-i18next';
import i18n from '../../utils/i18n/i18n';

import GenreGetter from '../user/userProfileBuilder/fields/genresGetter';
import LanguageGetter from '../user/userProfileBuilder/fields/languages';

const getFilterOptions = (t) => [
  {key: 'genres', text: t('Genres'), value: 'genres'},
  {key: 'language', text: t('Language'), value: 'language'},
  {key: 'rating', text: t('Rating'), value: 'rating'}
];
const filterOperatorOptions = [
  {key: 'in', text: i18n.t('Includes'), value: 'in'},
  {key: 'nin', text: i18n.t('DoesNotInclude'), value: 'nin'},
  {key: 'and', text: i18n.t('IncludesAll'), value: 'and'}
];

const ratingOperatorOptions = [
  {key: 'gte', text: i18n.t('AtLeast'), value: 'gte'}
];

class ReaderIndexFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleReaderFilterTypeChange = newType => {
    const {option, value, index} = this.props;
    this.props.handleFilterChange({
      type: newType,
      option: newType === 'rating' ? 'gte' : (option || 'in'),
      value: newType === 'rating' ? 0 : (value || []),
      index
    });
  };

  handleReaderFilterOptionChange = newOption => {
    const {type, value, index} = this.props;
    this.props.handleFilterChange({
      type,
      option: newOption,
      value: value || [],
      index
    });
  };

  handleReaderFilterValueChange = newValue => {
    const {type, option, index} = this.props;
    this.props.handleFilterChange({
      type,
      option,
      value: newValue,
      index
    });
  };

  handleSelectedGenresChanged = selectedGenres => {
    this.handleReaderFilterValueChange(selectedGenres);
  };

  handleSelectedLanguagesChanged = (
    selectedLanguageValues,
    selectedLanguages
  ) => {
    this.handleReaderFilterValueChange(selectedLanguageValues);
  };

  handleRatingChange = (e, { rating }) => {
    this.handleReaderFilterValueChange(rating);
  };

  render() {
    const {t, addFilter, removeFilter, type, option, value, index} = this.props;
    return (
      <List.Item>
        <List.Content verticalAlign='middle'>
          <Dropdown
            key={`select-filter-type-${type}`}
            style={{marginBottom: '10px'}}
            button
            compact
            placeholder={t('SelectFilter')}
            options={getFilterOptions(t)}
            value={type}
            onChange={(event, data) =>
              this.handleReaderFilterTypeChange(data.value)
            }
          />
          {['genres'].includes(type) && (
            <span>
              <Dropdown
                key={`select-filter-option-${type}`}
                button
                compact
                options={filterOperatorOptions}
                value={option || 'in'}
                onChange={(event, data) => {
                  this.handleReaderFilterOptionChange(data.value);
                }}
              />
              <GenreGetter
                header={t('Genres')}
                subheader=' '
                initialValue={value || ''}
                autoUpdate
                hideHeader
                dropDown
                onUpdate={this.handleSelectedGenresChanged}
                hideSaveButton
              />
            </span>
          )}
          {['language'].includes(type) && (
            <span>
              <Dropdown
                button
                compact
                options={filterOperatorOptions}
                value={option || 'in'}
                onChange={(event, data) => {
                  this.handleReaderFilterOptionChange(data.value);
                }}
              />
              <LanguageGetter
                header={t('Languages')}
                subheader=' '
                autoUpdate
                compact
                initialValue={value || ''}
                // initialValue={selectedLanguages && selectedLanguages.map(lang => lang.key)}
                onUpdate={this.handleSelectedLanguagesChanged}
              />
            </span>
          )}
          {['rating'].includes(type) && (
            <span>
              <Button
                compact
                disabled
                style={{marginRight: '10px', backgroundColor: 'var(--br-raised-surface)', color: 'var(--br-muted)'}}
              >
                {t('AtLeast')}
              </Button>
              <div style={{display: 'inline-block', marginLeft: '10px', verticalAlign: 'middle'}}>
                <Rating
                  icon="star"
                  rating={value || 0}
                  maxRating={5}
                  size="large"
                  onRate={this.handleRatingChange}
                />
                <span style={{marginLeft: '10px', fontSize: '14px', color: '#666'}}>
                  {value ? t('StarsOrMore', { count: value }) : t('SelectMinimumRating')}
                </span>
              </div>
            </span>
          )}
          <Media style={{marginTop: '10px'}} at='mobile'>
            {((Array.isArray(value) && value.length > 0) || (typeof value === 'number' && value > 0)) && (
              <Button
                disabled={
                  !value || (Array.isArray(value) && value.length === 0) || (type === 'rating' && !value)
                }
                floated='left'
                basic
                size='mini'
                onClick={() => addFilter(index)}
                icon>
                <Icon name='plus' />
              </Button>
            )}
            <Button
              floated='right'
              basic
              size='mini'
              onClick={() => removeFilter(index)}
              icon>
              <Icon name='trash' />
            </Button>
          </Media>
        </List.Content>
        <List.Content floated='right' verticalAlign='middle'>
          <Media style={{marginTop: '10px'}} greaterThan='mobile'>
            <Button size='mini' onClick={() => removeFilter(index)}>
              {t('RemoveFilter')}
            </Button>
            <Button
              disabled={!value || (Array.isArray(value) && value.length === 0) || (type === 'rating' && !value)}
              size='mini'
              onClick={() => addFilter(index)}>
              {t('AddFilter')}
            </Button>
          </Media>
        </List.Content>
      </List.Item>
    );
  }
}

export default withTranslation()(ReaderIndexFilter);
